import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import IndividualCategoryBehaviour from "./routes/IndividualCategoryBehaviour";
export default store => {
  return {
    path: "category",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "category" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [IndividualCategoryBehaviour(store)],
  };
};
